var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type === "inline"
    ? _c(
        "div",
        { staticClass: "lang-switch" },
        _vm._l(_vm.languages, function(lang, idx) {
          return _c(
            "a",
            {
              key: idx,
              staticClass: "u-reset lang-switch--inline-item",
              class: _vm.getItemClass(lang.label),
              attrs: { href: lang.path }
            },
            [_vm._v("\n        " + _vm._s(lang.label) + "\n    ")]
          )
        })
      )
    : _c("div", { staticClass: "lang-switch" }, [
        _vm.isOverlayOpen
          ? _c("div", {
              staticClass: "lang-switch--backdrop",
              on: { click: _vm.toggleOverlay }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "lang-switch--toggle",
            on: { click: _vm.toggleOverlay }
          },
          [
            _vm._v("\n        " + _vm._s(_vm.currentLang) + "\n        "),
            _c("base-icon", {
              staticClass: "lang-switch--chevron",
              class: _vm.chevronClass,
              attrs: {
                slot: "indicator",
                symbol: "chevron-down",
                size: "small"
              },
              slot: "indicator"
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.isOverlayOpen
          ? _c(
              "div",
              { staticClass: "lang-switch--overlay" },
              _vm._l(_vm.languages, function(lang, idx) {
                return _c(
                  "a",
                  {
                    key: idx,
                    staticClass: "u-reset lang-switch--item",
                    class: _vm.getItemClass(lang.label),
                    attrs: { href: lang.path }
                  },
                  [_vm._v("\n            " + _vm._s(lang.label) + "\n        ")]
                )
              })
            )
          : _vm._e()
      ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44f90fe3", { render: render, staticRenderFns: staticRenderFns })
  }
}